export enum ConsentType {
  PRIVACY_POLICY = 'wiley-terms-and-privacy',
  LEGACY_PRIVACY_POLICY = 'wiley-terms-and-privacy',
  PIPL = 'pipl-policy',
}
